import React, { Component } from 'react'
import styles from "./count-down.css";

export default class CountDown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      countDownTime: this.props.countDownTime,
      timer: null
    }
    
  }
  componentDidMount() {
    let timer = window.setInterval(() => {
      if (this.state.countDownTime === 0) {
        window.clearTimeout(timer)
        return
      }
      this.setState({
        countDownTime: --this.state.countDownTime
      })
    }, 1000)
    this.setState({
      timer: timer
    })
  }
  render() {
    /* 倒计时没有则不限时 */
    
    const hasCountDown = this.state.countDownTime;
    return <div>
            {hasCountDown || hasCountDown == 0 ? <div className='count-down-warp'>
                    <div>
                        <img src={require("./clock.png")} />
                    </div>
                    <span>倒计时</span>
                    <div className='count-down'>
                        <i>{parseInt(this.state.countDownTime / 60)}</i>
                        <em>分</em>
                        <i>{this.state.countDownTime % 60}</i>
                        <em>秒</em>
                    </div>
                </div> : []}
        </div>;
  }
}
